export const visit = (vm, at) => {
at({ "en": { "breezeDealImport": { "setupPrompt": "Help me import deals into HubSpot." } } });
};